import { gql } from "@apollo/client";

export const GET_TOKEN = gql`
  query GetToken($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
        rolesGuids
        sessionGuid
      }
    }
  }
`